/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { regusLogoCss } from './index.styles';

export const LOGO_TYPES = {
  BLACK: 'dark',
  WHITE: 'white',
};

export const RegusLogo = ({ type = LOGO_TYPES.BLACK, customCss = {} }) => (
  <i css={[regusLogoCss(type), customCss]} className="icon-logo" title="Regus">
    <i className="path1" />
    <i className="path2" />
    <i className="path3" />
    <i className="path4" />
  </i>
);

RegusLogo.propTypes = {
  type: PropTypes.string,
  customCss: PropTypes.object,
};
